<template>
  <div class="home-partner flex-col section">
    <homeTitleVue txt="PARTNERSHIP" v-if="showTitle" />
    <div class="flex-row justify-between home-partner-list">
      <div>
        <a href="https://www.xuetangx.com/" target="_blank">
          <img src="../../../assets/images/logo-xuetang.png" alt />
        </a>
        <p v-if="showName">学堂在线</p>
      </div>
      <div>
        <a href="https://www.cast.cn/" target="_blank">
          <img src="../../../assets/images/logo-space.png" alt />
        </a>
        <p v-if="showName">中国空间技术研究院</p>
      </div>
      <div>
        <a
          href="http://www.tuef.tsinghua.edu.cn/info/xwdt/3702"
          target="_blank"
        >
          <img src="../../../assets/images/logo-huahe.png" alt />
        </a>
        <p v-if="showName">华和</p>
      </div>
      <div>
        <a
          href="https://www.chec.bj.cn/"
          target="_blank"
        >
          <img src="../../../assets/images/logo-harbour.jpg" alt />
        </a>
        <p v-if="showName">中国港湾</p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import homeTitleVue from "./home-title.vue";

export default defineComponent({
  name: "HomeForum",
  components: { homeTitleVue },
  props: {
    showTitle: { type: Boolean, default: true },
    showName: { type: Boolean, default: false },
  },
  setup() {
    // 此处应该有防抖函数
    return {};
  },
});
</script>
<style lang="scss" scoped>
.home-partner {
  .home-partner-list {
    padding: 0;
    margin-top: 30px;
    a {
      width: 310px;
      height: 91px;
      background: #ffffff;
      border: 1px solid #cdcdcd;
      text-align: center;
      object-fit: cover;
      overflow: hidden;
      display: block;
      &:hover {
        box-shadow: 0px 0px 20px 0px rgba(81, 85, 106, 0.14);
      }
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    p {
      height: 22px;
      font-size: 16px;
      font-weight: 600;
      color: #423e3d;
      line-height: 22px;
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
